//libs and utilities
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { BREAKPOINT } from 'src/app-lang';
import { Link } from 'react-router-dom';
import { fetchLogin, sendDetails } from './login-dux';
import { browserHistory } from 'react-router';
import {withRouter} from "react-router-dom";
import { fetchUserLogin } from '../header/header-dux';
import {errorJSON}from '../utils/errorMessage'; 
import validationErrorStyle from "../utils/errorStyle"; 
import validation,  {errorMessage }from "../utils/validation"; 
/*   Components
 *
 *   1. Login 
 *
 */

class Login extends React.Component {
	constructor( props ) {
		super( props );
		this.state =  {
			errorMessage: {}
		}, 
		this.postData =  {
			loginuserId:"userId", 
			loginpassword:"password"
		}
	}
	
    componentWillMount() {
		if(this.props.location.search) {
			var the_string = this.props.location.search;
			var source = the_string.split("?",2)[1].split("=",2)[1];
			
			this.props.fetchLogin(source);
		}else {
			this.props.fetchLogin();
		}
		
		this.props.fetchUserLogin();
    }
	
	componentDidUpdate(){
		if(this.props.authenticated == 'HomePageData'){
			this.props.history.push("/home/");
		} else if(this.props.authenticated == 'SpinWin'){
            this.props.history.push("/spin/");
        }
	}
		
	submitDetails = ( e ) => {
		e.preventDefault();
		const form = e.target;
		const data = {};
		let keys = Object.keys(this.postData); 
		for (let element of form.elements) {
			for (let i = 0; i < keys.length; i++) {
				if (keys[i] === element.name) {
					data[this.postData[keys[i]]] = element.value 
				}
			}
		}
		if (validation(form)) {
			this.props.sendDetails(data); 
		}
		this.setState( {errorMessage}); 
		validationErrorStyle(e.target, errorMessage);
	}
    
    render() {
		let loginDetails = this.props.login;
		let pageName= loginDetails.pageName;
        return(
            <section className="login login-bg-wrapper">
				{ pageName != undefined &&
					<div className="container">
						<div className="login-header">
							<h3>{loginDetails.landingCMS.header}</h3>
							<p>{loginDetails.landingCMS.text}</p>
						</div>
						<div className="login-form">
							<div className="form-container">
								<div className="register-wrapper">
									<p className="login-title">{loginDetails.landingCMS.notamember}</p>
									<Link to="/enroll" className="btn btn-primary">{loginDetails.landingCMS.enrollnow}</Link>
								</div>
								<div className="login-wrapper">
									<form role="form" name="memberLogin" onSubmit={this.submitDetails} autoComplete="off">
										<div className="form-group">
											<p className="login-title">{loginDetails.landingCMS.memberalready}</p>
											<input type="text" name="hidden_input" style={{display: 'none'}} defaultValue="text" />
											<input type="password" name="hidden_input" style={{display: 'none'}} defaultValue="12345678!Zz" />
											{this.props.loginStatus != '' ? <p className="errors error-failure_bg" dangerouslySetInnerHTML={{ __html: this.props.errorMessage }}  /> : '' }
											<label htmlFor="userId">
												<input type="text" id="userId" name="loginuserId" className="form-control" placeholder="Username" />
												<p className = "errorMessage" > {errorJSON[this.state.errorMessage.loginuserId]}</p>
											</label>
											<label htmlFor="password">
												<input type="password" id="password" name="loginpassword" className="form-control" placeholder="Password" />
												<p className = "errorMessage"> {errorJSON[this.state.errorMessage.loginpassword]}</p>
											</label>
											<span className="forgot-link"><Link to="/forgotpassword">{loginDetails.landingCMS.forgotusername}</Link></span>
											<button type="submit" className="btn btn-primary">{loginDetails.landingCMS.login}</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				}
            </section>
        );
    }
}

export default withRouter(connect(
    ( state ) => {
        return {
            login: state.login,
			authenticated: state.login.authenticated,
			loginStatus: state.login.loginStatus,
			errorMessage: state.login.errorMessage
        };
    },
    ( dispatch ) => bindActionCreators( { fetchLogin, sendDetails, fetchUserLogin }, dispatch )
)( Login ));



// WEBPACK FOOTER //
// ./src/login/login.jsx